import React from 'react';
import { TechHero } from '../components/tech/TechHero';
import { TechMachines } from '../components/tech/TechMachines';
import { StatsSection } from '../components/StatsSection';
import { TechGrid } from '../components/tech/TechGrid';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

export const Technology: React.FC = () => {
  return (
    <main className="bg-black min-h-screen w-full">
        <SEO 
          title="Machinery & Technology - PrintAura"
          description="Discover PrintAura's advanced printing technology and machinery. High-precision offset printing, die-cutting, automated folding, and premium finishing for perfect mono-cartons."
          keywords="printing technology, offset printing, die-cutting, packaging machinery, automated folding, premium finishing"
          url="https://printaura.co.in/technology"
        />
        <TechHero />
        <TechMachines />
        <StatsSection variant="dark" />
        <TechGrid />
        <Testimonials darkMode={true} />
        <Footer darkMode={true} />
    </main>
  );
};
